/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
(function (angular) {
    angular.module('app')
        .controller('featuredPollController', featuredPollController);

    featuredPollController.$inject = [
        'featuredPoll',
        'PollVotesApi',
    ];

    function featuredPollController(
        featuredPoll,
        PollVotesApi,
    ) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const vm = this;

        vm.vote = vote;
        vm.poll = featuredPoll;

        /**
         * Sends the user's chosen option to the API, and shows the results
         * @param {object} feedItem - The poll voted on
         * @param {object} option - User's chosen option
         * @return {void}
         */
         function vote(feedItem, option) {
            feedItem.selectedOption = option;

            // if selected option not set.
            if (!feedItem.selectedOption.id) {
                return;
            }

            var data = {
                poll_option_id: feedItem.selectedOption.id
            };

            PollVotesApi.vote(data, function (response) {
                feedItem.options = response.data.poll_options;
                feedItem.current_users_vote = feedItem.selectedOption.id;
            });
        }
        
    }
}(angular));
